// extracted by mini-css-extract-plugin
module.exports = {"price":"bv-z","onSale":"cv-z"};